<div class="column">
  <app-card-dashboard
    *ngFor="let card of cards"
    [title]="card.title | translate"
    [iconClass]="card.iconClass"
    [imgSrc]="card.imgSrc"
    [disabled]="card.disabled"
    [comingSoon]="card.comingSoon"
    [description]="card.description | translate"
    (linkClick)="navigateAndHandleClick(card.callback)">
  </app-card-dashboard>
</div>

<!--
  The carousel and the mobile app promo share one slot at the end of the page.
  Campaign content is Portuguese-only, so non-Portuguese languages skip the
  carousel entirely; otherwise a published campaign wins the slot, and with
  none to show, the promo takes it back.
-->
@if (isPortugueseLanguage) {
  <app-campaign-carousel (hasCampaigns)="onCarouselResolved($event)" />
}

@if (hasCampaigns === false || !isPortugueseLanguage) {
  <div class="mobile-app-promo">
    <div class="mobile-app-promo__image">
      <img src="assets/images/default/new-mobile-mockup-shadow.png" alt="isoFarm Mobile App" />
    </div>
    <div class="mobile-app-promo__content">
      <span class="mobile-app-promo__badge">{{ 'dashboard.mobile-badge' | translate }}</span>
      <h2 class="mobile-app-promo__title">{{ 'dashboard.mobile-title' | translate }}</h2>
      <p class="mobile-app-promo__description">{{ 'dashboard.mobile-description' | translate }}</p>
      <p class="mobile-app-promo__description">{{ 'dashboard.mobile-description-2' | translate }}</p>
      <p class="mobile-app-promo__description">{{ 'dashboard.mobile-description-3' | translate }}</p>
      <ul class="mobile-app-promo__features">
        <li><i class="agres-check"></i> {{ 'dashboard.mobile-feature-1' | translate }}</li>
        <li><i class="agres-check"></i> {{ 'dashboard.mobile-feature-2' | translate }}</li>
        <li><i class="agres-check"></i> {{ 'dashboard.mobile-feature-3' | translate }}</li>
        <li><i class="agres-check"></i> {{ 'dashboard.mobile-feature-4' | translate }}</li>
        <li><i class="agres-check"></i> {{ 'dashboard.mobile-feature-5' | translate }}</li>
      </ul>
      <div class="mobile-app-promo__stores">
        <a [href]="appStoreLink" target="_blank" rel="noopener">
          <img [src]="'assets/images/default/app-store-badge-' + currentLang + '.svg'" alt="App Store" />
        </a>
        <a [href]="googlePlayLink" target="_blank" rel="noopener">
          <img [src]="'assets/images/default/google-play-badge-' + currentLang + '.svg'" alt="Google Play" />
        </a>
      </div>
    </div>
  </div>
}
